export class GeofenceInfo {
}
//# sourceMappingURL=geofence-info.js.map